import { callAuthorizedGraphQLEndpoint } from './../../../../../Module/graphQL'
import { CONFIG } from '../../../../../Config/config'

const getPostcodesByAIGeneration = async cityId => {
  const query = `query ($cityId: ID!) {
    city(id: $cityId) {
        name
        postcodesAndLocationsInsideDistributionZones{
          postcodes{
            postcode
            locations{
              id
              name
            }
          }
          isDistributionZoneExists
        }
      }
    }
  `

  return await callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

const generateAIMissions = async ({
  campaignId,
  cityId,
  cityName,
  countOfMissions,
  startDate,
  authorizedLocationIds,
  forcedLocationIds,
}) => {
  const req = await fetch(CONFIG.OPPIZI_ML_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': `8euHDMFhnha1wFjfExEqp7iPEAOfVHfX42Xzu8J3`,
    },
    body: JSON.stringify({
      'city_id': cityId,
      'city_name': cityName,
      'campaign_id': campaignId,
      'num_missions': countOfMissions,
      'start_date': startDate,
      'authorized_location_ids': authorizedLocationIds,
      'forced_location_ids': forcedLocationIds,
      'date_blacklist': [],
    }),
  })
  if (req.status === 500) {
    throw new Error('ML API failed')
  }
  const resp = await req.json()
  return resp
}

const createMissions = async ({
  missionsByChunks,
  totalAmount,
  onProgress,
  campaignId,
}) => {
  const mutation = `
  mutation createMissions ($input: CreateMissionsInput!) {
    createMissions(input: $input) {
      missions { 
        id
        status
        dateTime
        distributionCost
        costPerFlyer
        draftPayAdjustment
        printingCostPerFlyer
        bonusPerConversion
        bonusRedemptionPeriod
        type
        label
        location {
          id
          name
          hasPermit
          rank
          detailedRank
          type {
            name
          }
        }
        cityPlan { 
          id 
        }
        boundary {
          latitude
          longitude
        }
        boundaryColour
        amountScans
        campaign { id, name }
      }
    }
  }
`

  let createdMissions = []

  for (let index = 0; index < missionsByChunks.length; index++) {
    const missionsInChunk = missionsByChunks[index]
    const variables = {
      input: {
        missions: missionsInChunk,
        relatedCampaign: +campaignId || null,
      },
    }
    const req = await callAuthorizedGraphQLEndpoint(mutation, variables, {
      ignoreErrors: true,
    })
    const result = await req.json()
    createdMissions = [
      ...createdMissions,
      ...((result.data.createMissions && result.data.createMissions.missions) ||
        []),
    ]
    if (onProgress) {
      onProgress({
        itemsPerChunk: missionsInChunk.length,
        processedAmount: createdMissions.length,
        totalAmount,
      })
    }
  }
  return createdMissions
}

export { getPostcodesByAIGeneration, generateAIMissions, createMissions }
